import { render, staticRenderFns } from "./LongText.vue?vue&type=template&id=1d6e3a3f&"
import script from "./LongText.vue?vue&type=script&lang=js&"
export * from "./LongText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports